export const NAME = "notification";
export const NOTIFICATION_TIMEOUT = 30000;
